<template>
	<div class="transport_xunjia">
		<el-form :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }" v-if="t_id!=''">
			<el-row>
				<el-col :span="24">
					<transportmain :ref="'transportmain_'+l_id" @transportmainrollback="transportmainrollback"
						:title="xunjia_lang.baseinfo" :isdetail="isdetail"></transportmain>
				</el-col>
			</el-row>
			<el-row v-if="isshowcargo">
				<el-col :span="24">
					<gridlist :ref="'xj_cargolist_'+l_id" :item="item" :isdetail="isdetail" 
					:title="xunjia_lang.cargolisttitle"></gridlist>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<transportmain :ref="'transportmain_other_'+l_id" :item="item"
						@transportmainrollback="transportmainrollback" :title="xunjia_lang.remarktitle" :isdetail="isdetail">
					</transportmain>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<transportmain :ref="'transportmain_nb_'+l_id" :item="item"
						@transportmainrollback="transportmainrollback" :title="xunjia_lang.nbtitle" :isdetail="isdetail">
					</transportmain>
				</el-col>
			</el-row>
		</el-form>
		<el-row v-if="!btnhidden&&!isdetail&&t_id!=''" class="footerhandler">
			<el-col :span="5" class="submitBtn_switch" style="text-align: right;color:transparent">1</el-col>
			<el-col :span="4" class="submitBtn">
				<div @click="saveorder">{{$lang.label.public.savebtn}}</div>
			</el-col>
			<el-col :span="4" class="submitBtn_cancel">
				<div @click="cancel">{{$lang.label.public.cancel}}</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import Utils from '../../lib/util.js';
	import transportmain from '@/components/transport/transportmain.vue';
	import gridlist from '@/components/tools/gridlist.vue'

	export default {
		components: {
			transportmain,
			gridlist
		},
		props: {
			item: {
				type: Object,
				default: function() {
					return {

					};
				}
			},
			l_id: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				xunjia_lang: {},
				windowHeight: window.innerHeight - 150,
				orderinfo: '',
				p_no: '',
				iscopy: '',
				divclass: 'transport_xunjia',
				t_id: '',
				btnhidden: false,
				checkedpmode: '',
				type: '集运询价',
				isdetail:false,
				isshowcargo:false,
				t_syscol:'',
			}
		},
		methods() {
			import('../../static/' + this.$theme + '/style/transport.scss');
			//this.init();
		},
		methods: {
			transportmainrollback(e) {
				var that=this;
				debugger
				if (e.event == 'change') {
					this.t_id='';
					this.t_syscol='';
					this.isshowcargo=false;
					this.checkedpmode = e.value;
					this.GetPageLayout();
				}
				if(e.event=='showcargo'){
					that.isshowcargo=e.value;
					if(e.value){//显示商品明细
						this.$nextTick(function() {
							that.$refs['xj_cargolist_' + that.l_id].init({
								syscol: that.t_syscol,
								orderinfo: that.orderinfo,
								iscopy: that.iscopy,
								pkval: that.p_pkval,
								t_id: that.t_id,
								p_mode:that.checkedpmode,
								type: that.type+'-cargo-'+that.checkedpmode
							});
						});
					}
				}
			},
			cancel() {
				//debugger
				Utils.$emit('handleRermove', localStorage.getItem('tabname'));
			},
			init(param) {
				//debugger
				if(param.isdetail!=undefined)
					this.isdetail=param.isdetail;
					
				this.p_no = ''; //2023011234555
				if (param.pkval != undefined) this.p_no = param.pkval;
				var that = this;
				this.$public.GetLanguageByMode(this.type, this).then(res => {
					//debugger
					if (res.state == '1')
						that.xunjia_lang = that.$lang.label[that.type];
					//that.btnhidden = false;
					//that.p_no='1686009656184';
					if (that.p_no == '')
						that.GetPageLayout();
					else
						that.GetOrderInfo();
				});
			},
			//获取订单信息
			GetOrderInfo() {
				//获取订单信息
				var that = this;
				this.$tool.loading(that.$lang.label.public.loading, this.divclass);
				var paraminfo = {
					pkval: this.p_no,
					l_id: this.l_id
				}
				this.$apipost.get.GetOrderInfoByLid({
					paraminfo: paraminfo
				}).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						that.orderinfo = res;
						that.GetPageLayout();
					} else
						this.$tool.message(that.$lang.label.public.getinfofailed, "0");
				});
			},
			GetPageLayout() {
				var that = this;
				//this.truncatepage();
				this.$tool.loading(that.$lang.label.public.loading, this.divclass);
				//判断是哪种类型的下单功能,显示对应组件
				this.$apipost.get.GetTransFormat({
					p_mode: ''
				}).then(res => {
					this.$tool.loadingclose();
					//console.log('组件',res);
					if (res.state == '1') {
						debugger
						if (res.set != undefined) {
							if (that.checkedpmode != '') {
								if (res.set.t_type == that.type && res.set.p_mode == that.checkedpmode) {
									that.t_id = res.set.t_id;
									if (that.p_no != '')
										that.orderinfo = that.$tool.TransOrderInfo(res.set.pagetranscol, that);
									
									that.checkedpmode=res.set.p_mode;
									that.t_syscol=res.set.t_syscol;
									this.$nextTick(function() {
										that.$refs['transportmain_' + that.l_id].init({
											syscol: res.set.t_syscol,
											orderinfo: that.orderinfo,
											iscopy: that.iscopy,
											pkval: that.p_pkval,
											t_id: that.t_id,
											p_mode: res.set.p_mode,
											type: that.type
										});
										
										that.$refs['transportmain_other_' + that.l_id].init({
											syscol: res.set.t_syscol,
											orderinfo: that.orderinfo,
											iscopy: that.iscopy,
											pkval: that.p_pkval,
											t_id: that.t_id,
											p_mode: res.set.p_mode,
											type: that.type+'-other'
										});
										that.$refs['transportmain_nb_' + that.l_id].init({
											syscol: res.set.t_syscol,
											orderinfo: that.orderinfo,
											iscopy: that.iscopy,
											pkval: that.p_pkval,
											t_id: that.t_id,
											p_mode: res.set.p_mode,
											type: that.type+'-nb'
										});
									});
								}
							} else {
								if (res.set.t_type == that.type) {
									that.t_id = res.set.t_id;
									if (that.p_no != '')
										that.orderinfo = that.$tool.TransOrderInfo(res.set.pagetranscol, that);
									//that.type=res.set.t_type ;
									that.checkedpmode=res.set.p_mode;
									that.t_syscol=res.set.t_syscol;
									this.$nextTick(function() {
										that.$refs['transportmain_' + that.l_id].init({
											syscol: res.set.t_syscol,
											orderinfo: that.orderinfo,
											iscopy: that.iscopy,
											pkval: that.p_pkval,
											t_id: that.t_id,
											p_mode: res.set.p_mode,
											type: that.type
										});
										that.$refs['transportmain_other_' + that.l_id].init({
											syscol:res.set.t_syscol,
											orderinfo: that.orderinfo,
											iscopy: that.iscopy,
											pkval: that.p_pkval,
											t_id: that.t_id,
											p_mode: res.set.p_mode,
											type: that.type+'-other'
										});
										that.$refs['transportmain_nb_' + that.l_id].init({
											syscol: res.set.t_syscol,
											orderinfo: that.orderinfo,
											iscopy: that.iscopy,
											pkval: that.p_pkval,
											t_id: that.t_id,
											p_mode: res.set.p_mode,
											type: that.type+'-nb'
										});
									});
								}
							}
						}
						if (that.t_id == '') {
							var list = [];
							if (that.checkedpmode != '') {
								list = res.list.filter(function(re) {
									return re.t_type == that.type && re.p_mode == that.checkedpmode;
								});
							} else {
								list = res.list.filter(function(re) {
									return re.t_type == that.type;
								});
							}
							if (list.length > 0) {
								that.t_syscol=list[0].t_syscol;
								that.t_id = list[0].t_id;
								that.checkedpmode=list[0].p_mode;
								
								if (that.p_no != '')
									that.orderinfo = that.$tool.TransOrderInfo(list[0].pagetranscol, that);
			
								//that.type=list[0].t_type;
								this.$nextTick(function() {
									that.$refs['transportmain_' + that.l_id].init({
										syscol: list[0].t_syscol,
										orderinfo: that.orderinfo,
										iscopy: that.iscopy,
										pkval: that.p_pkval,
										t_id: that.t_id,
										p_mode: list[0].p_mode,
										type: that.type
									});
									that.$refs['transportmain_other_' + that.l_id].init({
										syscol: list[0].t_syscol,
										orderinfo: that.orderinfo,
										iscopy: that.iscopy,
										pkval: that.p_pkval,
										t_id: that.t_id,
										p_mode:list[0].p_mode,
										type: that.type+'-other'
									});
									that.$refs['transportmain_nb_' + that.l_id].init({
										syscol: list[0].t_syscol,
										orderinfo: that.orderinfo,
										iscopy: that.iscopy,
										pkval: that.p_pkval,
										t_id: that.t_id,
										p_mode:list[0].p_mode,
										type: that.type+'-nb'
									});
								});
							}
						}
					}
				});
			},
			saveorder() {
				var that=this;
				var orderinfo=this.$tool.getOrderinfo(this.$refs['transportmain_'+this.l_id]._data,this.p_no,this);
				debugger
				if(this.isshowcargo){
					if(orderinfo!='')
					   orderinfo=this.$tool.getOrderinfo(this.$refs['xj_cargolist_'+this.l_id]._data,this.p_no,this,orderinfo);
				}
				if(orderinfo!='')
				   orderinfo=this.$tool.getOrderinfo(this.$refs['transportmain_other_'+this.l_id]._data,this.p_no,this,orderinfo);
				if(orderinfo!='')
				   orderinfo=this.$tool.getOrderinfo(this.$refs['transportmain_nb_'+this.l_id]._data,this.p_no,this,orderinfo);
				
				if(orderinfo!=''){
					if(this.p_no=='')
						orderinfo.u_userid=localStorage.getItem('userid');
					else
						orderinfo.editid=this.p_no;
					orderinfo.t_id=that.t_id;
					this.btnhidden=true;
					this.$tool.loading(that.$lang.label.public.saving, this.divclass);
					this.$apipost.post.SaveInfo({ paraminfo: orderinfo }).then(res => {
						this.$tool.loadingclose();
						that.btnhidden=false;
						if (res.state == '1') {
							this.$tool.message(that.$lang.label.public.savesuccess, "1");
							setTimeout(function(){
								that.cancel();
							},1000);
						}
						else
							this.$tool.message(res.message, "0");
							//this.$tool.message(that.xunjia_lang[res.message], "0");
					});
				}
			}
		}
	}
</script>

<style>
</style>